import { render, staticRenderFns } from "./MRegister.vue?vue&type=template&id=22cd350a&scoped=true&"
import script from "./MRegister.vue?vue&type=script&lang=js&"
export * from "./MRegister.vue?vue&type=script&lang=js&"
import style0 from "./MRegister.vue?vue&type=style&index=0&id=22cd350a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd350a",
  null
  
)

component.options.__file = "MRegister.vue"
export default component.exports